import React, { Component } from 'react';
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import {toggleDarkMode} from "../../actions/preferenceActions";
import {connect} from "react-redux";

class Header extends Component {

    constructor(props) {
        super(props);

        window._toggleDarkMode = this.props.toggleDarkMode;
    }

    componentDidCatch() {
        console.log("componentDidCatch > ")
    }

    componentDidUpdate() {
        console.log("componentDidUpdate > ")
    }

    buildHeader(header, active, modeDark){
        let builder = [];
        if(header){
            header.map((row, key) => {
                if (row.child && Array.isArray(row.child) && row.child.length > 0){
                    return builder.push(
                        <li className="menu-has-children" key={key}>
                            <Link to={ row.path } className={ active && active.includes(row.name) ? "active" : "" } >{ row.name }</Link>
                            <ul className={ modeDark ? "dark" : "" } >
                                { row.child.map((childRow, childKey) =>
                                    <li key={childKey}>
                                        <Link to={ childRow.path } className={ active && active.includes(childRow.name) ? "active" : "" } >{ childRow.name }</Link>
                                    </li>
                                ) }
                            </ul>
                        </li>
                    )
                }else {
                    return builder.push(
                        <li className="" key={key}>
                            <Link to={ row.path } className={ active && active === row.name ? "active" : "" }>{ row.name }</Link>
                        </li>
                    )
                }
            })
        }else{
            builder.push(
                <li className="">
                    <Link to="#" className="active">Error</Link>
                </li>
            );
        }

        return builder;
    }

    render(){
        const { active, modeDark, structures } = this.props;

        return (
            <>
                {/* Start Header Area */}
                <header id="header" className={ modeDark ? "dark" : "" }>
                    <div className="container main-menu">
                        <div className="row align-items-center d-flex">
                            <div id="logo">
                                <Link to="/"><img src={ require("../../img/logo.png") } alt="" title="" /></Link>
                            </div>
                            <nav id="nav-menu-container">
                                <ul className={"nav-menu" + (modeDark ? " white" : "") }>
                                    {
                                        this.buildHeader(structures.structure, active, modeDark)
                                    }
                                    <li>
                                        <span className="toggle-dark-mode">
                                            { this.props._preferences._dark ? <i className="fas fa-sun" style={{ fontSize: '25px' }}> </i> : <i className="fas fa-moon" style={{ fontSize: '25px' }}> </i> }
                                        </span>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </header>
                {/* End Header Area */}
            </>
        )
    }
}

Header.protoType = {
    _preferences: PropTypes.object.isRequired,
    structures: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    _preferences: state._preferences,
    structures: state.structures
});

export default connect(
  mapStateToProps,
  { toggleDarkMode }
)(Header);